import { addDays, differenceInCalendarDays, format, parseISO, startOfWeek } from "date-fns";

// Input is keyed by date ("2026-09-21" or "2026-09-21-1"), so moving to another
// week re-keys it to the same weekdays instead of leaving it behind.
export function weekShiftDays(fromDate: string, toDate: string) {
  const fromMonday = startOfWeek(parseISO(fromDate), { weekStartsOn: 1 });
  const toMonday = startOfWeek(parseISO(toDate), { weekStartsOn: 1 });
  return differenceInCalendarDays(toMonday, fromMonday);
}

function shiftKey(key: string, days: number) {
  const date = parseISO(key.slice(0, 10));
  const shifted = format(addDays(date, days), "yyyy-MM-dd");
  const suffix = key.slice(10); // "" for offline keys, "-1" / "-2" for slots
  return `${shifted}${suffix}`;
}

export function shiftKeys<T>(record: Record<string, T>, days: number) {
  if (days === 0) return record;
  const entries = Object.entries(record);
  const shifted = entries.map(([key, value]) => [shiftKey(key, days), value] as const);
  return Object.fromEntries(shifted);
}
